// extracted by mini-css-extract-plugin
export default {"bubble":"PublishBubble_bubble__qdkid","bubbleTitle":"PublishBubble_bubbleTitle__6LYk8","bubbleText":"PublishBubble_bubbleText__GC4aG"};